import Loader from "@/components/loader/Loader.vue";

export default {
  name: "Care",
  components: {
    Loader
  },
  data() {
    return {
      loading: true,
      saving: false,
      careSettings: {
        dailyPlan: [
          {
            title: 'Medications',
            name: 'medications',
            enabled: true,
            actions: [
              { title: 'Add SD Setup / Change', name: 'addSDSetup', enabled: true },
              { title: 'Add Medication', name: 'addMedication', enabled: true },
              { title: 'Add PRN medication', name: 'addPRNMedication', enabled: true },
              { title: 'Add Cream', name: 'addCream', enabled: true },
              { title: 'Add Insulin', name: 'addInsulin', enabled: true }
            ],
          },
          {
            title: 'Ad-hoc Actions',
            name: 'adHocActions',
            enabled: true,
            actions: [
              {
                title: 'Soft drink',
                name: 'softDrink',
                enabled: true,
                actions: [
                  { title: 'Reminisce', name: 'reminisce', enabled: true },
                  { title: 'Stayed in room', name: 'stayedInRoom', enabled: true },
                  { title: 'Returned to room', name: 'returnedToRoom', enabled: true },
                ]
              },
              {
                title: 'Bell',
                name: 'bell',
                enabled: true,
                actions: [
                  { title: 'Loose bowels', name: 'looseBowels', enabled: true },
                  { title: 'Wet clothes', name: 'wetClothes', enabled: true },
                  { title: 'Soiled clothes', name: 'soiledClothes', enabled: true },
                ]
              },
              {
                title: 'Fall',
                name: 'fall',
                enabled: true,
                actions: [
                  { title: 'In pain', name: 'inPain', enabled: true },
                  { title: 'Sick', name: 'sick', enabled: true },
                  { title: 'Call doctor', name: 'callDoctor', enabled: true },
                  { title: 'Ambulance', name: 'ambulance', enabled: true },
                  { title: 'Choking intervention', name: 'chokingIntervention', enabled: true },
                  { title: 'Epileptic seizure', name: 'epilepticSeizure', enabled: true },
                ]
              },
              {
                title: 'Wandering',
                name: 'wandering',
                enabled: true,
                actions: [
                  { title: 'Disturbed', name: 'disturbed', enabled: true },
                  { title: 'Stay in bed', name: 'stayInBed', enabled: true },
                  { title: 'Monitoring', name: 'monitoring', enabled: true },
                ]
              },
              { title: 'Fluid note', name: 'fluidNote', enabled: true },
              { title: 'Ice cream', name: 'iceCream', enabled: true },
              { title: 'Agitated', name: 'agitated', enabled: true },
              { title: 'Confused', name: 'confused', enabled: true },
              { title: 'Pacing', name: 'pacing', enabled: true },
              { title: 'Upset', name: 'upset', enabled: true },
              { title: 'Repetitive', name: 'repetitive', enabled: true },
              { title: 'Hallucinate', name: 'hallucinate', enabled: true },
              { title: 'Disinhibited', name: 'disinhibited', enabled: true },
              { title: 'Handover', name: 'handover', enabled: true },
              { title: 'Resumed', name: 'resumed', enabled: true },
              { title: 'Record height', name: 'recordHeight', enabled: true },
              { title: 'Complaint', name: 'complaint', enabled: true },
              { title: 'Compliment', name: 'compliment', enabled: true },
            ],
          },
          {
            title: 'Recurring Actions',
            name: 'recurringActions',
            enabled: true,
            actions: [
              {
                title: 'Personal Care',
                name: 'personalCare',
                enabled: true,
                actions: [
                  { title: 'Wash', name: 'wash', enabled: true },
                  { title: 'Dressed', name: 'dressed', enabled: true },
                  { title: 'Change clothes', name: 'changeClothes', enabled: true },
                  { title: 'Bath', name: 'bath', enabled: true },
                  { title: 'Bath temperature', name: 'bathTemperature', enabled: true },
                  { title: 'Shower', name: 'shower', enabled: true },
                  { title: 'Oral hygiene', name: 'oralHygiene', enabled: true },
                  { title: 'Denture care', name: 'dentureCare', enabled: true },
                  { title: 'Wash hands', name: 'washHands', enabled: true },
                  { title: 'Hair wash', name: 'hairWash', enabled: true },
                  { title: 'Hair brushed', name: 'hairBrushed', enabled: true },
                  { title: 'Catheter care', name: 'catheterCare', enabled: true },
                  { title: 'Shave', name: 'shave', enabled: true },
                  { title: 'Make Up', name: 'makeUp', enabled: true },
                  { title: 'Menstruation', name: 'menstruation', enabled: true },
                  { title: 'Check finger nails', name: 'checkFingerNails', enabled: true },
                  { title: 'Cleaning', name: 'cleaning', enabled: true },
                  { title: 'Hairdresser', name: 'hairdresser', enabled: true },
                  { title: 'Chiropodist', name: 'chiropodist', enabled: true },
                  { title: 'Check toe nails', name: 'checkToeNails', enabled: true },
                  { title: 'Glasses', name: 'checkGlasses', enabled: true },
                  { title: 'Check ears', name: 'checkEars', enabled: true },
                  { title: 'Hearing aid', name: 'hearingAid', enabled: true },
                  { title: 'Check eye', name: 'checkEye', enabled: true },
                  { title: 'Laundry', name: 'laundry', enabled: true },
                  { title: 'Personal Care Other', name: 'personalCareOther', enabled: true }
                ]
              },
              {
                title: 'Personal Safety and Environment',
                name: 'personalSafetyAndEnvironment',
                enabled: true,
                actions: [
                  { title: 'Fridge Temperature', name: 'fridgeTemperature', enabled: true },
                  { title: 'Check OK', name: 'checkOK', enabled: true },
                  { title: 'Change bed', name: 'changeBed', enabled: true },
                  { title: 'Check mattress', name: 'checkMattress', enabled: true },
                  { title: 'Check chair', name: 'checkChair', enabled: true },
                  { title: 'Check bedrails', name: 'checkBedrails', enabled: true },
                  { title: 'Action mat', name: 'actionMat', enabled: true },
                  { title: 'Check Wheelchair', name: 'checkWheelchair', enabled: true },
                  { title: 'Wheelchair belt', name: 'wheelchairBelt', enabled: true },
                  { title: 'Check sling', name: 'checkSling', enabled: true },
                  { title: 'Adjust curtains', name: 'adjustCurtains', enabled: true },
                  { title: 'Check room', name: 'checkRoom', enabled: true },
                  { title: 'Room temperature', name: 'roomTemperature', enabled: true },
                  { title: 'Check footwear', name: 'checkFootwear', enabled: true },
                  { title: 'Check equipment', name: 'checkEquipment', enabled: true },
                  { title: 'Pendant alarm', name: 'pendantAlarm', enabled: true }
                ]
              },
              {
                title: 'Nutrition, Eating, and Drinking',
                name: 'nutritionEatingAndDrinking',
                enabled: true,
                actions: [
                  { title: 'Breakfast', name: 'breakfast', enabled: true },
                  { title: 'Lunch', name: 'lunch', enabled: true },
                  { title: 'Tea (meal)', name: 'teaMeal', enabled: true },
                  { title: 'Snack', name: 'snack', enabled: true },
                  { title: 'Supper', name: 'supper', enabled: true },
                  { title: 'Soup', name: 'soup', enabled: true },
                  { title: 'Fluid cap', name: 'fluidCap', enabled: true },
                  { title: 'Jelly Drops', name: 'jellyDrops', enabled: true },
                  { title: 'Fluid watch', name: 'fluidWatch', enabled: true },
                  { title: 'Pudding', name: 'pudding', enabled: true },
                  { title: 'Jelly', name: 'jelly', enabled: true },
                  { title: 'Ice lolly', name: 'iceLolly', enabled: true },
                  { title: 'Tea (drink)', name: 'teaDrink', enabled: true },
                  { title: 'Coffee', name: 'coffee', enabled: true },
                  { title: 'Hot chocolate', name: 'hotChocolate', enabled: true },
                  { title: 'Drink', name: 'drink', enabled: true },
                  { title: 'Water', name: 'water', enabled: true },
                  { title: 'Juice', name: 'juice', enabled: true },
                  { title: 'Milk', name: 'milk', enabled: true },
                  { title: 'Milkshake', name: 'milkshake', enabled: true },
                  { title: 'Thick drink', name: 'thickDrink', enabled: true },
                  { title: 'Ensure', name: 'ensure', enabled: true },
                  { title: 'Alcoholic drink', name: 'alcoholicDrink', enabled: true },
                  { title: 'Fluid watch', name: 'fluidWatch', enabled: true },
                  { title: 'Nutrition watch', name: 'nutritionWatch', enabled: true },
                  { title: 'Weigh', name: 'weigh', enabled: true },
                  { title: 'Food order', name: 'foodOrder', enabled: true },
                  { title: 'Eat out', name: 'eatOut', enabled: true },
                  { title: 'Cafe', name: 'cafe', enabled: true },
                  { title: 'Wine', name: 'wine', enabled: true },
                  { title: 'Nutrition Eating & Drinking-Other', name: 'nutritionEatingDrinkingOther', enabled: true }
                ]
              },
              {
                title: 'Activities',
                name: 'activities',
                enabled: true,
                actions: [
                  { title: 'Oomph! Explorer', name: 'oomphExplorer', enabled: true },
                  { title: 'Oomph! Wireless', name: 'oomphWireless', enabled: true },
                  { title: 'Oomph! Exercise', name: 'oomphExercise', enabled: true },
                  { title: 'Oomph! Digest', name: 'oomphDigest', enabled: true },
                  { title: 'Oomph! Calendar', name: 'oomphCalendar', enabled: true },
                  { title: 'Oomph! OnDemand', name: 'oomphOnDemand', enabled: true },
                  { title: 'Armchair excercises', name: 'armchairExercises', enabled: true },
                  { title: 'Arts/Crafts', name: 'artsCrafts', enabled: true },
                  { title: 'Ball games', name: 'ballGames', enabled: true },
                  { title: 'BBQ', name: 'BBQ', enabled: true },
                  { title: 'Bingo', name: 'bingo', enabled: true },
                  { title: 'Birthday', name: 'birthday', enabled: true },
                  { title: 'Bowling', name: 'bowling', enabled: true },
                  { title: 'Church', name: 'church', enabled: true },
                  { title: 'Cigarette', name: 'cigarette', enabled: true },
                  { title: 'Vape', name: 'vape', enabled: true },
                  { title: 'Cinema', name: 'cinema', enabled: true },
                  { title: 'Computer', name: 'computer', enabled: true },
                  { title: 'Concert', name: 'concert', enabled: true },
                  { title: 'Cooking', name: 'cooking', enabled: true },
                  { title: 'Crossword', name: 'crossword', enabled: true },
                  { title: 'Dominoes', name: 'dominoes', enabled: true },
                  { title: 'Driving', name: 'driving', enabled: true },
                  { title: 'Day Centre', name: 'dayCentre', enabled: true },
                  { title: 'Drama', name: 'drama', enabled: true },
                  { title: 'Entertainer', name: 'entertainer', enabled: true },
                  { title: 'Exercise', name: 'exercise', enabled: true },
                  { title: 'Fete', name: 'fete', enabled: true },
                  { title: 'Film', name: 'film', enabled: true },
                  { title: 'Played Game', name: 'playedGame', enabled: true },
                  { title: 'Gardening', name: 'gardening', enabled: true },
                  { title: 'Games console', name: 'gamesConsole', enabled: true },
                  { title: 'Horse riding', name: 'horseRiding', enabled: true },
                  { title: 'Housework', name: 'housework', enabled: true },
                  { title: 'Knitting', name: 'knitting', enabled: true },
                  { title: 'Massage', name: 'massage', enabled: true },
                  { title: 'Music', name: 'music', enabled: true },
                  { title: 'Outing', name: 'outing', enabled: true },
                  { title: 'Party', name: 'party', enabled: true },
                  { title: 'Pets', name: 'pets', enabled: true },
                  { title: 'Pub', name: 'pub', enabled: true },
                  { title: 'Quiz', name: 'quiz', enabled: true },
                  { title: 'Relaxation', name: 'relaxation', enabled: true },
                  { title: 'Reading', name: 'reading', enabled: true },
                  { title: 'ReMe', name: 'reMe', enabled: true },
                  { title: 'Interactive Me', name: 'interactiveMe', enabled: true },
                  { title: 'Sensory', name: 'sensory', enabled: true },
                  { title: 'Daily Sparkle', name: 'dailySparkle', enabled: true },
                  { title: 'Digital Table', name: 'digitalTable', enabled: true },
                  { title: 'Shopping', name: 'shopping', enabled: true },
                  { title: 'Community', name: 'community', enabled: true },
                  { title: 'Singing', name: 'singing', enabled: true },
                  { title: 'Indoor skittles', name: 'indoorSkittles', enabled: true },
                  { title: 'Swimming', name: 'swimming', enabled: true },
                  { title: 'Theatre', name: 'theatre', enabled: true },
                  { title: 'Watched TV', name: 'watchedTV', enabled: true },
                  { title: 'Visit relatives', name: 'visitRelatives', enabled: true },
                  { title: 'Visitor', name: 'visitor', enabled: true },
                  { title: 'Walk outside', name: 'walkOutside', enabled: true },
                  { title: 'Sitting room', name: 'sittingRoom', enabled: true },
                  { title: 'PEC Schedule', name: 'PECSchedule', enabled: true },
                  { title: 'Magical', name: 'magical', enabled: true },
                  { title: 'Activities-Other', name: 'activitiesOther', enabled: true }
                ]
              },
              {
                title: 'Communication',
                name: 'communication',
                enabled: true,
                actions: [
                  { title: 'Help reading', name: 'helpReading', enabled: true },
                  { title: 'Help writing', name: 'helpWriting', enabled: true },
                  { title: 'Speaking', name: 'speaking', enabled: true },
                  { title: 'Chatted', name: 'chatted', enabled: true },
                  { title: 'Read letter', name: 'readLetter', enabled: true },
                  { title: 'Newspaper', name: 'newspaper', enabled: true },
                  { title: 'Write letter', name: 'writeLetter', enabled: true },
                  { title: 'Email', name: 'email', enabled: true },
                  { title: 'Phone', name: 'phone', enabled: true },
                  { title: 'Mentoring', name: 'mentoring', enabled: true },
                  { title: 'Can’t communicate', name: 'cantCommunicate', enabled: true },
                  { title: 'Communication-Other', name: 'communicationOther', enabled: true }
                ]
              },
              {
                title: 'Toileting',
                name: 'toileting',
                enabled: true,
                actions: [
                  { title: 'Toilet help', name: 'toiletHelp', enabled: true },
                  { title: 'Bed pan', name: 'bedPan', enabled: true },
                  { title: 'Urine bottle', name: 'urineBottle', enabled: true },
                  { title: 'Commode', name: 'commode', enabled: true },
                  { title: 'Pad check', name: 'padCheck', enabled: true },
                  { title: 'Pad checked', name: 'padChecked', enabled: true },
                  { title: 'Pad was checked', name: 'padWasChecked', enabled: true },
                  { title: 'Urinate', name: 'urinate', enabled: true },
                  { title: 'Bowels opened', name: 'bowelsOpened', enabled: true },
                  { title: 'Emptied', name: 'emptied', enabled: true },
                  { title: 'Help with toilet', name: 'helpWithToilet', enabled: true },
                  { title: 'Toileting-Other', name: 'toiletingOther', enabled: true }
                ]
              },
              {
                title: 'Mobility',
                name: 'mobility',
                enabled: true,
                actions: [
                  { title: 'Onto chair', name: 'ontoChair', enabled: true },
                  { title: 'Up from Chair', name: 'upFromChair', enabled: true },
                  { title: 'Into bed', name: 'intoBed', enabled: true },
                  { title: 'Out of Bed', name: 'outOfBed', enabled: true },
                  { title: 'Hoist 2 People', name: 'hoist2People', enabled: true },
                  { title: 'Standing hoist', name: 'standingHoist', enabled: true },
                  { title: 'Handling belt', name: 'handlingBelt', enabled: true },
                  { title: 'Elevate legs', name: 'elevateLegs', enabled: true },
                  { title: 'Moved', name: 'moved', enabled: true },
                  { title: 'Walk', name: 'walk', enabled: true },
                  { title: 'Stairs', name: 'stairs', enabled: true },
                  { title: 'Reposition', name: 'reposition', enabled: true },
                  { title: 'Mobility-Other', name: 'mobilityOther', enabled: true }
                ]
              },
              {
                title: 'Medical',
                name: 'medical',
                enabled: true,
                actions: [
                  { title: 'Medication', name: 'medication', enabled: true },
                  { title: 'PRN Medication', name: 'prnMedication', enabled: true },
                  { title: 'Doctor', name: 'doctor', enabled: true },
                  { title: 'Nurse', name: 'nurse', enabled: true },
                  { title: 'Specialist', name: 'specialist', enabled: true },
                  { title: 'Professional', name: 'professional', enabled: true },
                  { title: 'Massage', name: 'massage', enabled: true },
                  { title: 'Wound', name: 'wound', enabled: true },
                  { title: 'Heat pack', name: 'heatPack', enabled: true },
                  { title: 'Cream', name: 'cream', enabled: true },
                  { title: 'Foot splint', name: 'footSplint', enabled: true },
                  { title: 'Hand splint', name: 'handSplint', enabled: true },
                  { title: 'Compression', name: 'compression', enabled: true },
                  { title: 'Skin integrity', name: 'skinIntegrity', enabled: true },
                  { title: 'Neuro OBS', name: 'neuroObs', enabled: true },
                  { title: 'Pulse', name: 'pulse', enabled: true },
                  { title: 'Blood test', name: 'bloodTest', enabled: true },
                  { title: 'Blood sugar', name: 'bloodSugar', enabled: true },
                  { title: 'Soft signs', name: 'softSigns', enabled: true },
                  { title: 'Insulin', name: 'insulin', enabled: true },
                  { title: 'Temperature', name: 'temperature', enabled: true },
                  { title: 'Blood pressure', name: 'bloodPressure', enabled: true },
                  { title: 'Blood O2', name: 'bloodO2', enabled: true },
                  { title: 'Blood INR', name: 'bloodINR', enabled: true },
                  { title: 'Respiration', name: 'respiration', enabled: true },
                  { title: 'Coronavirus', name: 'coronavirus', enabled: true },
                  { title: 'Consciousness', name: 'consciousness', enabled: true },
                  { title: 'NEWS2', name: 'news2', enabled: true },
                  { title: 'In pain', name: 'inPain', enabled: true },
                  { title: 'PAP therapy', name: 'papTherapy', enabled: true },
                  { title: 'Oxygen level', name: 'oxygenLevel', enabled: true },
                  { title: 'SD Check', name: 'sdCheck', enabled: true },
                  { title: 'SD Setup/Change', name: 'sdSetupChange', enabled: true },
                  { title: 'New catheter', name: 'newCatheter', enabled: true },
                  { title: 'Washout', name: 'washout', enabled: true },
                  { title: 'Add Bag', name: 'addBag', enabled: true },
                  { title: 'Cleaned', name: 'cleaned', enabled: true },
                  { title: 'PEG', name: 'peg', enabled: true },
                  { title: 'Stoma', name: 'stoma', enabled: true },
                  { title: 'Suction', name: 'suction', enabled: true },
                  { title: 'Tracheostomy', name: 'tracheostomy', enabled: true },
                  { title: 'Enema', name: 'enema', enabled: true },
                  { title: 'IV line flush', name: 'ivLineFlush', enabled: true },
                  { title: 'Sample', name: 'sample', enabled: true },
                  { title: 'Multistix', name: 'multistix', enabled: true },
                  { title: 'Ear syringe', name: 'earSyringe', enabled: true },
                  { title: 'Clinic', name: 'clinic', enabled: true },
                  { title: 'Hospital', name: 'hospital', enabled: true },
                  { title: 'Coronavirus symptom check', name: 'coronavirusSymptomCheck', enabled: true },
                  { title: 'Medical-Other', name: 'medicalOther', enabled: true }
                ]
              },
              {
                title: 'Emotional Support',
                name: 'emotionalSupport',
                enabled: true,
                actions: [
                  { title: 'Distress reaction', name: 'distressReaction', enabled: true },
                  { title: 'Social worker', name: 'socialWorker', enabled: true },
                  { title: 'Paranoid', name: 'paranoid', enabled: true },
                  { title: 'Emotional support', name: 'emotionalSupport', enabled: true }
                ]
              },
              {
                title: 'Sleeping',
                name: 'sleeping',
                enabled: true,
                actions: [
                  { title: 'Check sleep', name: 'checkSleep', enabled: true },
                  { title: 'Check pad', name: 'checkPad', enabled: true },
                  { title: 'Sleeping-Other', name: 'sleepingOther', enabled: true }
                ]
              },
              {
                title: 'Process',
                name: 'process',
                enabled: true,
                actions: [
                  { title: 'Shift handover', name: 'shiftHandover', enabled: true },
                  { title: 'Visit', name: 'visit', enabled: true },
                  { title: 'Visit 1', name: 'visit1', enabled: true },
                  { title: 'Visit 2', name: 'visit2', enabled: true },
                  { title: 'Visit start', name: 'visitStart', enabled: true },
                  { title: 'Manager', name: 'manager', enabled: true },
                  { title: 'Personal money', name: 'personalMoney', enabled: true },
                  { title: 'Suspended', name: 'suspended', enabled: true },
                  { title: 'Relative', name: 'relative', enabled: true },
                  { title: 'Transport', name: 'transport', enabled: true },
                  { title: 'Keyworker', name: 'keyworker', enabled: true }
                ]
              }
            ]
          }
        ],
        dailyCare: [
          {
            title: 'Personal Care',
            name: 'personalCare',
            enabled: true,
            actions: [
              { title: 'Wash', name: 'wash', enabled: true },
              { title: 'Dressed', name: 'dressed', enabled: true },
              { title: 'Change clothes', name: 'changeClothes', enabled: true },
              { title: 'Bath', name: 'bath', enabled: true },
              { title: 'Bath temperature', name: 'bathTemperature', enabled: true },
              { title: 'Shower', name: 'shower', enabled: true },
              { title: 'Oral hygiene', name: 'oralHygiene', enabled: true },
              { title: 'Denture care', name: 'dentureCare', enabled: true },
              { title: 'Wash hands', name: 'washHands', enabled: true },
              { title: 'Hair wash', name: 'hairWash', enabled: true },
              { title: 'Hair brushed', name: 'hairBrushed', enabled: true },
              { title: 'Catheter care', name: 'catheterCare', enabled: true },
              { title: 'Shave', name: 'shave', enabled: true },
              { title: 'Make-up', name: 'makeUp', enabled: true },
              { title: 'Menstruation', name: 'menstruation', enabled: true },
              { title: 'Check finger nails', name: 'checkFingerNails', enabled: true },
              { title: 'Cleaning', name: 'cleaning', enabled: true },
              { title: 'Hairdresser', name: 'hairdresser', enabled: true },
              { title: 'Chiropodist', name: 'chiropodist', enabled: true },
              { title: 'Check toe nails', name: 'checkToeNails', enabled: true },
              { title: 'Glasses', name: 'checkGlasses', enabled: true },
              { title: 'Check ears', name: 'checkEars', enabled: true },
              { title: 'Hearing aid', name: 'hearingAid', enabled: true },
              { title: 'Check eye', name: 'checkEye', enabled: true },
              { title: 'Laundry', name: 'laundry', enabled: true },
              { title: 'Teeth/mouth cleaned', name: 'teethMouthCleaned', enabled: true },
              { title: 'Personal Care-Other', name: 'personalCareOther', enabled: true }
            ]
          },
          {
            title: 'Personal Safety and Environment',
            name: 'personalSafetyAndEnvironment',
            enabled: true,
            actions: [
              { title: 'Fridge temperature', name: 'fridgeTemperature', enabled: true },
              { title: 'Check OK', name: 'checkOK', enabled: true },
              { title: 'Change bed', name: 'changeBed', enabled: true },
              { title: 'Check mattress', name: 'checkMattress', enabled: true },
              { title: 'Check chair', name: 'checkChair', enabled: true },
              { title: 'Check bedrails', name: 'checkBedrails', enabled: true },
              { title: 'Action mat', name: 'actionMat', enabled: true },
              { title: 'Check Wheelchair', name: 'checkWheelchair', enabled: true },
              { title: 'Wheelchair belt', name: 'wheelchairBelt', enabled: true },
              { title: 'Check sling', name: 'checkSling', enabled: true },
              { title: 'Adjust curtains', name: 'adjustCurtains', enabled: true },
              { title: 'Check room', name: 'checkRoom', enabled: true },
              { title: 'Room temperature', name: 'roomTemperature', enabled: true },
              { title: 'Check footwear', name: 'checkFootwear', enabled: true },
              { title: 'Check equipment', name: 'checkEquipment', enabled: true },
              { title: 'Pendant alarm', name: 'pendantAlarm', enabled: true }
            ]
          },
          {
            title: 'Nutrition Eating and Drinking',
            name: 'nutritionEatingAndDrinking',
            enabled: true,
            actions: [
              { title: 'Breakfast', name: 'breakfast', enabled: true },
              { title: 'Lunch', name: 'lunch', enabled: true },
              { title: 'Tea (meal)', name: 'teaMeal', enabled: true },
              { title: 'Snack', name: 'snack', enabled: true },
              { title: 'Supper', name: 'supper', enabled: true },
              { title: 'Soup', name: 'soup', enabled: true },
              { title: 'Jelly Drops', name: 'jellyDrops', enabled: true },
              { title: 'Pudding', name: 'pudding', enabled: true },
              { title: 'Jelly', name: 'jelly', enabled: true },
              { title: 'Ice lolly', name: 'iceLolly', enabled: true },
              { title: 'Ice cream', name: 'iceCream', enabled: true },
              { title: 'Soft drink', name: 'softDrink', enabled: true },
              { title: 'Tea (drink)', name: 'teaDrink', enabled: true },
              { title: 'Coffee', name: 'coffee', enabled: true },
              { title: 'Hot chocolate', name: 'hotChocolate', enabled: true },
              { title: 'Drink', name: 'drink', enabled: true },
              { title: 'Water', name: 'water', enabled: true },
              { title: 'Juice', name: 'juice', enabled: true },
              { title: 'Milk', name: 'milk', enabled: true },
              { title: 'Milkshake', name: 'milkshake', enabled: true },
              { title: 'Thick Drink', name: 'thickDrink', enabled: true },
              { title: 'Ensure', name: 'ensure', enabled: true },
              { title: 'Wine', name: 'wine', enabled: true },
              { title: 'Alcoholic drink', name: 'alcoholicDrink', enabled: true },
              { title: 'Fluid watch', name: 'fluidWatch', enabled: true },
              { title: 'Nutrition watch', name: 'nutritionWatch', enabled: true },
              { title: 'Weigh', name: 'weigh', enabled: true },
              { title: 'Food order', name: 'foodOrder', enabled: true },
              { title: 'Eat out', name: 'eatOut', enabled: true },
              { title: 'Café', name: 'cafe', enabled: true },
              { title: 'Fluid note', name: 'fluidNote', enabled: true },
              { title: 'Nutrition, Eating & Drinking Other', name: 'nutritionEatingDrinkingOther', enabled: true }
            ]
          },
          {
            title: 'Activities',
            name: 'activities',
            enabled: true,
            actions: [
              { title: 'Oomph! Explorer', name: 'oomphExplorer', enabled: true },
              { title: 'Oomph! Wireless', name: 'oomphWireless', enabled: true },
              { title: 'Oomph! Exercise', name: 'oomphExercise', enabled: true },
              { title: 'Oomph! Digest', name: 'oomphDigest', enabled: true },
              { title: 'Oomph! Calendar', name: 'oomphCalendar', enabled: true },
              { title: 'Oomph! On Demand', name: 'oomphOnDemand', enabled: true },
              { title: 'Armchair excercises', name: 'armchairExercises', enabled: true },
              { title: 'Arts/Crafts', name: 'artsCrafts', enabled: true },
              { title: 'Ball games', name: 'ballGames', enabled: true },
              { title: 'BBQ', name: 'bbq', enabled: true },
              { title: 'Bingo', name: 'bingo', enabled: true },
              { title: 'Birthday', name: 'birthday', enabled: true },
              { title: 'Bowling', name: 'bowling', enabled: true },
              { title: 'Church', name: 'church', enabled: true },
              { title: 'Cigarette', name: 'cigarette', enabled: true },
              { title: 'Vape', name: 'vape', enabled: true },
              { title: 'Cinema', name: 'cinema', enabled: true },
              { title: 'Computer', name: 'computer', enabled: true },
              { title: 'Concert', name: 'concert', enabled: true },
              { title: 'Cooking', name: 'cooking', enabled: true },
              { title: 'Crossword', name: 'crossword', enabled: true },
              { title: 'Dominoes', name: 'dominoes', enabled: true },
              { title: 'Driving', name: 'driving', enabled: true },
              { title: 'Day centre', name: 'dayCentre', enabled: true },
              { title: 'Drama', name: 'drama', enabled: true },
              { title: 'Entertainer', name: 'entertainer', enabled: true },
              { title: 'Exercise', name: 'exercise', enabled: true },
              { title: 'Fete', name: 'fete', enabled: true },
              { title: 'Film', name: 'film', enabled: true },
              { title: 'Played game', name: 'playedGame', enabled: true },
              { title: 'Gardening', name: 'gardening', enabled: true },
              { title: 'Games console', name: 'gamesConsole', enabled: true },
              { title: 'Horse riding', name: 'horseRiding', enabled: true },
              { title: 'Housework', name: 'housework', enabled: true },
              { title: 'Knitting', name: 'knitting', enabled: true },
              { title: 'Massage', name: 'massage', enabled: true },
              { title: 'Music', name: 'music', enabled: true },
              { title: 'Outing', name: 'outing', enabled: true },
              { title: 'Party', name: 'party', enabled: true },
              { title: 'Pets', name: 'pets', enabled: true },
              { title: 'Pub', name: 'pub', enabled: true },
              { title: 'Quiz', name: 'quiz', enabled: true },
              { title: 'Relaxation', name: 'relaxation', enabled: true },
              { title: 'Reading', name: 'reading', enabled: true },
              { title: 'ReMe', name: 'reMe', enabled: true },
              { title: 'Reminisce', name: 'reminisce', enabled: true },
              { title: 'Interactive Me', name: 'interactiveMe', enabled: true },
              { title: 'Sensory', name: 'sensory', enabled: true },
              { title: 'Daily Sparkle', name: 'dailySparkle', enabled: true },
              { title: 'Digital Table', name: 'digitalTable', enabled: true },
              { title: 'Shopping', name: 'shopping', enabled: true },
              { title: 'Community', name: 'community', enabled: true },
              { title: 'Singing', name: 'singing', enabled: true },
              { title: 'Indoor skittles', name: 'indoorSkittles', enabled: true },
              { title: 'Swimming', name: 'swimming', enabled: true },
              { title: 'Theatre', name: 'theatre', enabled: true },
              { title: 'Watched TV', name: 'watchedTV', enabled: true },
              { title: 'Visit relatives', name: 'visitRelatives', enabled: true },
              { title: 'Visitor', name: 'visitor', enabled: true },
              { title: 'Walk outside', name: 'walkOutside', enabled: true },
              { title: 'Stayed in room', name: 'stayedInRoom', enabled: true },
              { title: 'Sitting room', name: 'sittingRoom', enabled: true },
              { title: 'Returned to room', name: 'returnedToRoom', enabled: true },
              { title: 'PEC Schedule', name: 'pecSchedule', enabled: true },
              { title: 'Magical', name: 'magical', enabled: true },
              { title: 'Activities-Other', name: 'activitiesOther', enabled: true }
            ]
          },
          {
            title: 'Communication',
            name: 'communication',
            enabled: true,
            actions: [
              { title: 'Help reading', name: 'helpReading', enabled: true },
              { title: 'Help writing', name: 'helpWriting', enabled: true },
              { title: 'Speaking', name: 'speaking', enabled: true },
              { title: 'Chatted', name: 'chatted', enabled: true },
              { title: 'Read letter', name: 'readLetter', enabled: true },
              { title: 'Newspaper', name: 'newspaper', enabled: true },
              { title: 'Write letter', name: 'writeLetter', enabled: true },
              { title: 'Email', name: 'email', enabled: true },
              { title: 'Bell', name: 'bell', enabled: true },
              { title: 'Phone', name: 'phone', enabled: true },
              { title: 'Mentoring', name: 'mentoring', enabled: true },
              { title: "Can't communicate", name: 'cantCommunicate', enabled: true },
              { title: 'Communication-Other', name: 'communicationOther', enabled: true }
            ]
          },
          {
            title: 'Toileting',
            name: 'toileting',
            enabled: true,
            actions: [
              { title: 'Toilet help', name: 'toiletHelp', enabled: true },
              { title: 'Bed pan', name: 'bedPan', enabled: true },
              { title: 'Urine bottle', name: 'urineBottle', enabled: true },
              { title: 'Commode', name: 'commode', enabled: true },
              { title: 'Pad check', name: 'padCheck', enabled: true },
              { title: 'Pad checked', name: 'padChecked', enabled: true },
              { title: 'Pad was checked', name: 'padWasChecked', enabled: true },
              { title: 'Urinate', name: 'urinate', enabled: true },
              { title: 'Bowels opened', name: 'bowelsOpened', enabled: true },
              { title: 'Loose bowels', name: 'looseBowls', enabled: true },
              { title: 'Emptied', name: 'emptied', enabled: true },
              { title: 'Wet clothes', name: 'wetClothes', enabled: true },
              { title: 'Soiled clothes', name: 'soiledClothes', enabled: true },
              { title: 'Toileting-Other', name: 'toiletingOther', enabled: true }
            ]
          },
          {
            title: 'Mobility',
            name: 'mobility',
            enabled: true,
            actions: [
              { title: 'Onto chair', name: 'ontoChair', enabled: true },
              { title: 'Up from Chair', name: 'upFromChair', enabled: true },
              { title: 'Into bed', name: 'intoBed', enabled: true },
              { title: 'Out of Bed', name: 'outOfBed', enabled: true },
              { title: 'Assist to Bed', name: 'assistToBed', enabled: true },
              { title: 'Hoist 2 People', name: 'hoist2People', enabled: true },
              { title: 'Standing hoist', name: 'standingHoist', enabled: true },
              { title: 'Handling belt', name: 'handlingBelt', enabled: true },
              { title: 'Elevate legs', name: 'elevateLegs', enabled: true },
              { title: 'Moved', name: 'moved', enabled: true },
              { title: 'Walk', name: 'walk', enabled: true },
              { title: 'Stairs', name: 'stairs', enabled: true },
              { title: 'Reposition', name: 'reposition', enabled: true },
              { title: 'Fall', name: 'fall', enabled: true },
              { title: 'Mobility-Other', name: 'mobilityOther', enabled: true }
            ]
          },
          {
            title: 'Medical',
            name: 'medical',
            enabled: true,
            actions: [
              { title: 'Medication', name: 'medication', enabled: true },
              { title: 'PRN Medication', name: 'PRNMedication', enabled: true },
              { title: 'Doctor', name: 'doctor', enabled: true },
              { title: 'Nurse', name: 'nurse', enabled: true },
              { title: 'Specialist', name: 'specialist', enabled: true },
              { title: 'Professional', name: 'professional', enabled: true },
              { title: 'In pain', name: 'inPain', enabled: true },
              { title: 'Massage', name: 'massage', enabled: true },
              { title: 'Sick', name: 'sick', enabled: true },
              { title: 'Call doctor', name: 'callDoctor', enabled: true },
              { title: 'Ambulance', name: 'ambulance', enabled: true },
              { title: 'Wound', name: 'wound', enabled: true },
              { title: 'Heat pack', name: 'heatPack', enabled: true },
              { title: 'Cream', name: 'cream', enabled: true },
              { title: 'Foot splint', name: 'footSplint', enabled: true },
              { title: 'Hand splint', name: 'handSplint', enabled: true },
              { title: 'Compression', name: 'compression', enabled: true },
              { title: 'Skin integrity', name: 'skinIntegrity', enabled: true },
              { title: 'Neuro Obs', name: 'neuroObs', enabled: true },
              { title: 'Pulse', name: 'pulse', enabled: true },
              { title: 'Blood test', name: 'bloodTest', enabled: true },
              { title: 'Blood sugar', name: 'bloodSugar', enabled: true },
              { title: 'Soft signs', name: 'softSigns', enabled: true },
              { title: 'Insulin', name: 'insulin', enabled: true },
              { title: 'Temperature', name: 'temperature', enabled: true },
              { title: 'Blood pressure', name: 'bloodPressure', enabled: true },
              { title: 'Blood O2', name: 'bloodO2', enabled: true },
              { title: 'Blood INR', name: 'bloodINR', enabled: true },
              { title: 'Respiration', name: 'respiration', enabled: true },
              { title: 'Coronavirus', name: 'coronavirus', enabled: true },
              { title: 'Choking Intervention', name: 'chokingIntervention', enabled: true },
              { title: 'Consciousness', name: 'consciousness', enabled: true },
              { title: 'NEWS2', name: 'NEWS2', enabled: true },
              { title: 'PAP therapy', name: 'PAPTherapy', enabled: true },
              { title: 'Oxygen level', name: 'oxygenLevel', enabled: true },
              { title: 'SD Check', name: 'SDCheck', enabled: true },
              { title: 'SD Setup / Change', name: 'SDSetupChange', enabled: true },
              { title: 'New catheter', name: 'newCatheter', enabled: true },
              { title: 'Washout', name: 'washout', enabled: true },
              { title: 'Add bag', name: 'addBag', enabled: true },
              { title: 'Cleaned', name: 'cleaned', enabled: true },
              { title: 'PEG', name: 'PEG', enabled: true },
              { title: 'Epileptic seizure', name: 'epilepticSeizure', enabled: true },
              { title: 'Stoma', name: 'stoma', enabled: true },
              { title: 'Suction', name: 'suction', enabled: true },
              { title: 'Tracheostomy', name: 'tracheostomy', enabled: true },
              { title: 'Enema', name: 'enema', enabled: true },
              { title: 'IV line flush', name: 'IVLineFlush', enabled: true },
              { title: 'Sample', name: 'sample', enabled: true },
              { title: 'Multistix', name: 'multistix', enabled: true },
              { title: 'Ear syringe', name: 'earSyringe', enabled: true },
              { title: 'Clinic', name: 'clinic', enabled: true },
              { title: 'Hospital', name: 'hospital', enabled: true },
              { title: 'Medical-Other', name: 'medicalOther', enabled: true }
            ]
          },
          {
            title: 'Emotional Support',
            name: 'emotionalSupport',
            enabled: true,
            actions: [
              { title: 'Agitated', name: 'agitated', enabled: true },
              { title: 'Confused', name: 'confused', enabled: true },
              { title: 'Pacing', name: 'pacing', enabled: true },
              { title: 'Upset', name: 'upset', enabled: true },
              { title: 'Distress reaction', name: 'distressReaction', enabled: true },
              { title: 'Social worker', name: 'socialWorker', enabled: true },
              { title: 'Repetitive', name: 'repetitive', enabled: true },
              { title: 'Paranoid', name: 'paranoid', enabled: true },
              { title: 'Hallucinate', name: 'hallucinate', enabled: true },
              { title: 'Disinhibited', name: 'disinhibited', enabled: true },
              { title: 'Wandering', name: 'wandering', enabled: true },
              { title: 'Emotional support', name: 'emotionalSupport', enabled: true }
            ]
          },
          {
            title: 'Sleeping',
            name: 'sleeping',
            enabled: true,
            actions: [
              { title: 'Check sleep', name: 'checkSleep', enabled: true },
              { title: 'Check pad', name: 'checkPad', enabled: true },
              { title: 'Disturbed', name: 'disturbed', enabled: true },
              { title: 'Stay in bed', name: 'stayInBed', enabled: true },
              { title: 'Monitoring', name: 'monitoring', enabled: true },
              { title: 'Sleeping-Other', name: 'sleepingOther', enabled: true }
            ]
          },
          {
            title: 'Non-ADL',
            name: 'nonADL',
            enabled: true,
            actions: [
              { title: 'Visit', name: 'visit', enabled: true },
              { title: 'Handover', name: 'handover', enabled: true },
              { title: 'Manager', name: 'manager', enabled: true },
              { title: 'Personal money', name: 'personalMoney', enabled: true },
              { title: 'Resumed', name: 'resumed', enabled: true },
              { title: 'Record height', name: 'recordHeight', enabled: true },
              { title: 'Complaint', name: 'complaint', enabled: true },
              { title: 'Relative', name: 'relative', enabled: true },
              { title: 'Compliment', name: 'compliment', enabled: true },
              { title: 'Transport', name: 'transport', enabled: true },
              { title: 'Keyworker', name: 'keyworker', enabled: true }
            ]
          }
        ]
      }
    }
  },
  async created() {
    await this.$store.dispatch("getCareAPIParameters");
    this.updateEnabledStatus(this.careSettings, JSON.parse(this.facilityCareAPIParameters[0]?.parameters));
    this.loading = false;
  },
  computed: {
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    facilityCareAPIParameters() {
      return this.$store.state.facilityModule.facilityCareAPIParameters;
    }
  },
  methods: {
    async saveSettings() {
      this.saving = true;
      const filteredData = this.filterDisabledItems(this.careSettings);
      await this.$store.dispatch("updateCareAPIParameters", JSON.stringify(filteredData, null, 2));
      this.saving = false;
    },
    filterDisabledItems(obj) {
      function filterActions(actions) {
        return actions
          .map(action => {
            if (action.actions && Array.isArray(action.actions)) {
              const filteredSubActions = filterActions(action.actions);
              if (action.enabled === false || filteredSubActions.length > 0) {
                return { ...action, actions: filteredSubActions };
              }
              return null;
            }
            return action.enabled === false ? action : null;
          })
          .filter(Boolean);
      }

      const filteredDailyPlan = obj.dailyPlan
        .map(plan => {
          if (plan.actions && Array.isArray(plan.actions)) {
            const filteredActions = filterActions(plan.actions);
            if (plan.enabled === false || filteredActions.length > 0) {
              return { ...plan, actions: filteredActions };
            }
            return null;
          }
          return plan.enabled === false ? plan : null;
        })
        .filter(Boolean);

      const filteredDailyCare = obj.dailyCare
        .map(care => {
          if (care.actions && Array.isArray(care.actions)) {
            const filteredActions = filterActions(care.actions);
            if (care.enabled === false || filteredActions.length > 0) {
              return { ...care, actions: filteredActions };
            }
            return null;
          }
          return care.enabled === false ? care : null;
        })
        .filter(Boolean);

      return {
        dailyPlan: filteredDailyPlan,
        dailyCare: filteredDailyCare
      };
    },
    updateEnabledStatus(originalObj, filteredObj) {
      function updateActions(originalActions, filteredActions) {
        originalActions.forEach(originalAction => {
          const matchingFilteredAction = filteredActions.find(
            filteredAction => filteredAction.name === originalAction.name
          );

          if (matchingFilteredAction) {
            if (matchingFilteredAction.enabled === false) {
              originalAction.enabled = false;
            }

            if (originalAction.actions && matchingFilteredAction.actions) {
              updateActions(originalAction.actions, matchingFilteredAction.actions);
            }
          }
        });
      }

      originalObj.dailyPlan.forEach(originalPlan => {
        const matchingFilteredPlan = filteredObj.dailyPlan.find(
          filteredPlan => filteredPlan.name === originalPlan.name
        );

        if (matchingFilteredPlan) {
          if (matchingFilteredPlan.enabled === false) {
            originalPlan.enabled = false;
          }

          if (originalPlan.actions && matchingFilteredPlan.actions) {
            updateActions(originalPlan.actions, matchingFilteredPlan.actions);
          }
        }
      });

      originalObj.dailyCare.forEach(originalCare => {
        const matchingFilteredCare = filteredObj.dailyCare.find(
          filteredCare => filteredCare.name === originalCare.name
        );

        if (matchingFilteredCare) {
          if (matchingFilteredCare.enabled === false) {
            originalCare.enabled = false;
          }

          if (originalCare.actions && matchingFilteredCare.actions) {
            updateActions(originalCare.actions, matchingFilteredCare.actions);
          }
        }
      });
    },
    updatePlanAndActions(plan) {
      if (plan.actions && Array.isArray(plan.actions)) {
        plan.actions.forEach(action => {
          action.enabled = plan.enabled;
          if (action.actions && Array.isArray(action.actions)) {
            this.updatePlanAndActions(action);
          }
        });
      }
    },
    toggleEnabled(item) {
      this.updatePlanAndActions(item);
    },
  }
}